import { DefaultRequest } from 'scripts/api';

Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Edit = {

    editAnswer: function (question, answer) {

        this.createOverlay();
        this.addButtonListeners(question, answer);

        var input = document.querySelector('.editInput');
        input.value = answer.value;

    },

    removeAnswer: function (question, answer) {

        const confirmIsToDelete = () => {
            if (this.validateAnswerRemoval(question, answer)) {

                if (!question.alreadyEdited && question.toDelete) {
                    //prepare to delete answer on database, answers won't be in database if question has been edited
                    question.toDelete.push(answer)
                }
                this.removeAnswerData(question, answer);
            } else {
                new Greenmile.Components.AlertModal('Greenmile.Survey.Alert.CannotDeleteDefaultAnswer')
                    .show();
            }
        };

        new Greenmile.Components.AlertModal('Greenmile.Survey.Confirm.DeleteItem',
            null,
            confirmIsToDelete)
        .show();
    },

    removeAnswerData: function (question, answer) {

        var answerContent = $('#' + answer.id)[0],
            parent;

        parent = answerContent.parentNode;
        parent.removeChild(answerContent);

        Greenmile.Survey.Data.removeQuestionDomain(question, answer);
        Greenmile.Survey.Link.clearLinkObjectsForAnswer(answer.id);

    },

    validateAnswerRemoval: function (question, answer) {
        let defaultAnswerCount = 0;

        if (answer.value !== question.defaultAnswer){
            return true
        }
        else {
            question.surveyQuestionDomain.forEach((answer) => {
                if (answer.value === question.defaultAnswer) {
                    defaultAnswerCount += 1;
                }
            })

            //if there is more than one answer equals to default answer, user can erase answer
            if (defaultAnswerCount > 1) {
                return true;
            }
        }
        return false;
    },

    addButtonListeners: function (question, answer) {

        var saveButton   = document.getElementById('EditFormSaveButton'),
            cancelButton = document.getElementById('EditFormCancelButton');

        saveButton.addEventListener('click', (function (scopeQuestion, scope) {

            return function () {

                var input       = document.querySelector('.editInput'),
                    editedInput = input.value,
                    answerEl    = $('#' + answer.id + ' label')[0],
                    domain,
                    hasDifferentId,
                    hasSameText,
                    i;

                if (scopeQuestion.surveyQuestionDomain) {

                    for (i = 0; i < scopeQuestion.surveyQuestionDomain.length; i++) {

                        domain = scopeQuestion.surveyQuestionDomain[i];
                        hasDifferentId = (domain.id.toString() !== answer.id.toString());
                        hasSameText = domain.value.toUpperCase() === editedInput.toUpperCase();

                        if (hasDifferentId && hasSameText) {

                            new Greenmile.Components.AlertModal('Greenmile.Survey.DuplicateAnswers')
                                .show();
                            return;
                        }

                    }

                }

                answer.value = editedInput;
                answerEl.innerHTML = editedInput;

                scope.dismissAnswerForm();

            };

        }(question, this)));

        cancelButton.addEventListener('click', (function (scope) {

            return function () {

                scope.dismissAnswerForm();

            };

        }(this)));
    },

    createOverlay: function () {
        var popupElement        = document.querySelector('#Survey'),
            questionFormOverlay = document.createElement('div'),
            questionFormContent = document.createElement('div');

        questionFormOverlay.id = 'SurveyLinkOverlay';
        questionFormContent.id = 'SurveyEditForm';
        questionFormContent.appendChild(Greenmile.Survey.Templates.SurveyEditAnswerTemplate());

        popupElement.appendChild(questionFormOverlay);
        popupElement.appendChild(questionFormContent);
    },

    dismissAnswerForm: function () {
        var formOverlay   = document.querySelector('#SurveyLinkOverlay'),
            formContent   = document.querySelector('#SurveyEditForm'),
            overlayParent = formOverlay.parentNode,
            formParent    = formContent.parentNode;

        overlayParent.removeChild(formOverlay);
        formParent.removeChild(formContent);
    },

    deleteSurveySection: function (section) {

        var sectionData = Greenmile.Survey.Data.findSection(section);

        if (sectionData.isNew !== true) {

            const request = new DefaultRequest({
                url: 'SurveySection/' + section,
                method: 'delete'
            });
            request.send();

        }

    },

    deleteSurveyQuestion: function (question) {

        var questionData = Greenmile.Survey.Data.findQuestion(question);

        if (questionData.isNew !== true) {

            const request = new DefaultRequest({
                url: 'SurveyQuestion/' + question,
                method: 'delete'
            });
            request.send();

        }

    },

    deleteSurveyQuestionDomain: function (questionDomain) {

        if (questionDomain.isNew !== true) {

            const request = new DefaultRequest({
                url: 'SurveyQuestionDomain/' + questionDomain.id,
                method: 'delete'
            });
            request.send();

        }

    }

};
